export default __webpack_public_path__ + "static/media/filter.651f9471.svg";